const createApiCache = (cacheKeyPrefix, ttlMs = 5 * 60 * 1000) => {
  const getCacheKey = () => `prodyt_${cacheKeyPrefix}_cache`;

  const save = (data, identifier) => {
    try {
      const cacheData = {
        data,
        identifier,
        timestamp: Date.now()
      };
      localStorage.setItem(getCacheKey(), JSON.stringify(cacheData));
    } catch (error) {
      console.error(`Failed to save ${cacheKeyPrefix} data to localStorage:`, error);
    }
  };

  const get = (identifier) => {
    try {
      const cached = localStorage.getItem(getCacheKey());
      if (!cached) return null;

      const cacheData = JSON.parse(cached);
      const isExpired = Date.now() - cacheData.timestamp > ttlMs;
      const isSameIdentifier = cacheData.identifier === identifier;

      if (!isExpired && isSameIdentifier) {
        return cacheData.data;
      }

      return null;
    } catch (error) {
      console.error(`Failed to get ${cacheKeyPrefix} data from localStorage:`, error);
      return null;
    }
  };

  const clear = () => {
    try {
      localStorage.removeItem(getCacheKey());
    } catch (error) {
      console.error(`Failed to clear ${cacheKeyPrefix} data from localStorage:`, error);
    }
  };

  return { save, get, clear };
};

export const phoneCache = createApiCache('phone');
export const wabaIdCache = createApiCache('waba_id');
export const categoriesCache = createApiCache('categories', 10 * 60 * 1000);
export const plansCache = createApiCache('plans', 10 * 60 * 1000);

export const savePhoneToStorage = (phones, wabaId) => phoneCache.save(phones, wabaId);
export const getPhoneFromStorage = (wabaId) => phoneCache.get(wabaId);
export const clearPhoneFromStorage = () => phoneCache.clear();

export const saveWabaIdsToStorage = (wabaIds, companyId) => wabaIdCache.save(wabaIds, companyId);
export const getWabaIdsFromStorage = (companyId) => wabaIdCache.get(companyId);
export const clearWabaIdsFromStorage = () => wabaIdCache.clear();

export const saveCategoriesToStorage = (categories) => categoriesCache.save(categories, 'default');
export const getCategoriesFromStorage = () => categoriesCache.get('default');
export const clearCategoriesFromStorage = () => categoriesCache.clear();

export const savePlansToStorage = (plans) => plansCache.save(plans, 'default');
export const getPlansFromStorage = () => plansCache.get('default');
export const clearPlansFromStorage = () => plansCache.clear();
